<template>
  <div id="alertStickyBar"
       v-if="stickyData && showStickyData">
    <div class="sticky-modal"
         :class="{ active: !loading }"
         v-if="stickyData.type === 'modal'">
      <div class="dimmed">
        <div class="modal">
          <p class="title">
            <i v-if="stickyData.id === 'inactive'"
               class="inactive"></i>
            <strong v-html="stickyData.title"></strong>
          </p>
          <p class="date"
             v-if="stickyData.dateText">
            {{ stickyData.dateText }}
            <em>
              {{ planData.startDate | dashDate  }}
            </em>
          </p>
          <p v-if="stickyData.description"
             class="desc"
             v-html="stickyData.description"></p>
          <div v-if="stickyData.buttonText"
               class="buttons">
            <ui-button @click="onCloseLayer">
              {{ $t('common.cancel') }}
            </ui-button>
            <ui-button :primary="true"
                       @click="onActionClick">
              {{ stickyData.buttonText }}
            </ui-button>
          </div>
        </div>
      </div>
    </div>
    <div class="sticky-bar"
         :class="{ active: !loading }"
         v-else>
      <p class="title">
        <i class="icon icon--info-alert"></i>
        <strong>
          {{ stickyData.title }}
        </strong>
      </p>
      <p v-if="stickyData.description"
         class="desc" v-html="stickyData.description"></p>
      <div v-if="stickyData.buttonText"
           class="button--wrap">
        <ui-button class="btn__subscribe"
                   :primary="true"
                   @click="onActionClick">
          {{ stickyData.buttonText }}
        </ui-button>
        <ui-button class="btn__close"
                   :primary5="true"
                   @click="onCloseLayer">
          {{ $t('common.close') }}
        </ui-button>
      </div>
      <i class="icon icon--close-size26"
         @click="onCloseLayer"></i>
    </div>
  </div>
</template>

<script>
import { create } from 'vue-modal-dialogs'
import { mapState, mapMutations, mapActions } from 'vuex'
import { openContactUs } from '@/libs/utils'
import { getDomains } from '@/api/domain'
import { endInactivate } from '@/api/userPlan'
import { EventBus } from '../../libs/event-bus'

import AppDialog from '@/components/ui/AppDialog'
import UiButton from '@/components/ui/UiButton'

const openDialog = create(AppDialog)

export default {
  components: {
    UiButton
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showStickyData'
    ]),
    stickyData () {
      return this.planData ? this.planData.stickyData : null
    }
  },
  watch: {
    showStickyData () {
      this.initSticky()
    },
    stickyData () {
      this.initSticky()
    }
  },
  mounted () {
    this.initSticky()
  },
  methods: {
    ...mapMutations([
      'setShowStickyData'
    ]),
    ...mapActions([
      'storeUserData',
      'storePlanData'
    ]),
    initSticky () {
      this.additional = null
      if (this.stickyData && ['cardTypeDowngrade', 'notCardTypeDowngrade'].includes(this.stickyData.id)) {
        this.getMainDomain()
        EventBus.$on('mainDomainChanged', () => {
          this.getMainDomain(true)
        })
      }
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    getMainDomain (forceReload = false) {
      getDomains(null, forceReload || this.$route.name !== 'dashboard').then(result => {
        for (const domain of result) {
          if (domain.mainDomain) {
            this.additional = this.$t('payment.dialog.analyseReport') + ' : '
            this.additional += domain.domain
          }
        }
      })
    },
    onCloseLayer () {
      this.loading = true
      setTimeout(() => {
        this.setShowStickyData(false)
      }, 300)
    },
    onEndInactive () {
      endInactivate().then(() => {
        this.setPlanInfo()
        openDialog({
          dialogType: 'plan.planEndInactivate',
          ok: this.$t('common.confirm')
        })
      }).catch(() => {
        openDialog({
          dialogType: 'plan.planEndInactivateFailed',
          ok: this.$t('common.confirm')
        })
      })
    },
    setPlanInfo () {
      return this.storePlanData().then(data => {
        return this.storeUserData()
      })
    },
    onActionClick () {
      this.onCloseLayer()

      switch (this.stickyData.action) {
        case 'cancelPlanChange':
        case 'changePlan':
        case 'contactPlan':
          this.$router.push({
            name: 'managePlan',
            params: { action: this.stickyData.action },
            query: { ts: new Date().getTime() }
          })
          break
        case 'endInactive':
          this.onEndInactive()
          break
        case 'contactUs':
          if (this.planData.applyType === 'admin') {
            let form = this.$t('plan.contactForm')
            openContactUs(this.userData, form, true)
          } else {
            openContactUs(this.userData)
          }
          break
        case 'contactUsDowngrade':
          openContactUs(this.userData, this.$t('plan.downgradeForm', { planName: this.planData.planName }))
          break
        case 'goBilling':
          this.$router.push({ name: 'billing', params: { action: 'registerCard' } })
          break
      }
    }
  },
  data () {
    return {
      additional: null,
      loading: true
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.sticky-modal {
  position: fixed;
  z-index: 10000010;
  transition: opacity 0.3s ease;
  opacity: 0;

  &.active {
    opacity: 1;
  }

  .modal {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 530px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    box-sizing: border-box;
    transform: translate(-50%, -50%);

    .title {
      padding-top: 30px;

      i {
        display: block;
        margin: 0 auto 12px;

        &.inactive {
          width: 337px;
          height: 180px;
          background-image: url(../../assets/img/plan/character--inactive.svg);
        }
      }

      strong {
        font-size: 36px;
        font-weight: 600;
        line-height: 1.22;
        text-align: center;
        color: #555555;
        display: block;

        & /deep/ em {
          color: #ec0047;
        }
      }
    }

    .date {
      padding: 33px 30px;
      margin: 22px 30px 0 30px;
      border-radius: 5px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;
      font-size: 16px;
      color: #444444;

      em {
        float: right;
        color: #ec0047;
      }
    }

    .desc {
      margin: 22px 20px;
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
      color: #444444;
    }

    .buttons {
      margin: 38px 0 26px 0;
      text-align: center;

      .ui-btn {
        min-width: 104px;
        margin: 0 2px 0 3px;
      }
    }
  }
}
.sticky-bar {
  position: fixed;
  top: -200px;
  left: 0;
  z-index: 10000010;
  width: 100%;
  min-width: 1024px;
  height: 157px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 11px 23px 0 rgba(0, 0, 0, 0.33);
  background-color: #1b1b1b;
  padding-top: 24px;
  padding-left: 62px;
  padding-right: 66px;
  box-sizing: border-box;
  transition: top 0.3s cubic-bezier(.28,.12,.42,.94);

  &.active {
    top: 0;
  }

  .title {
    position: relative;
    color: #ffffff;
    padding-bottom: 2px;

    strong {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 24px;
      font-weight: 600;

      .additional {
        color: #ffffff;
        font-size: 14px;
        border-left: 1px solid #767676;
        padding-left: 10px;
        margin-left: 5px;
        position: relative;
        top: -3px;
      }
    }

    .icon {
      position: absolute;
      top: 50%;
      left: -30px;
      width: 22px;
      height: 22px;
      margin: -1px;
      transform: translateY(-50%);
    }
  }

  .desc {
    font-size: 16px;
    color: #c1c1c1;
    margin-top: 7px;
    padding-bottom: 1px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.4;
  }

  .button--wrap {
    margin-top: 15px;

    .ui-btn {
      padding: 0 20px;
    }

    .btn__close {
      margin-left: 5px;
      padding: 0 30px;
    }
  }

  .icon--close-size26 {
    position: absolute;
    top: 10px;
    right: 20px;
  }
}
</style>
